
<template>
  <div class="container">

    <div id="page-detail">

        <div class='title'>{{tittle}}</div>
        <div class='content' v-html="note">
        </div>

    </div>

    <a class="download" target="_blank" v-bind:href='url' v-if='visible' >{{ url.indexOf("tool:") >= 0 ? "打开软件" : "立即下载"}}</a>
    
  </div>
</template>

<script>
export default {
  name: 'PanneContent',
  props: {
    soft: String,
  },
  data () {
    return {
      visible: true,
      msg: 'Welcome to Your Vue.js App',
      menus:
      [
        {tittle: "首页", path:""},
        {tittle: "软件详情", path:""},
        {tittle: "留言", path:""}
      ],
      tittle: "",
      note: "note信息",
      url: "",
    }
  },

  mounted()
  {
    // this.soft = this.$route.params.soft;
  },
  created()
  {
    this.soft = this.$route.query.id;
    // this.$router.push({ path: '/soft', query: { id: 'easyicon' }});

    // this.soft = this.$route.params.id;
    // this.$router.push({ name: '/soft', params: { id: 'easyicon' }});
    
    var that = this;

    this.$CheckToolBox((haveToolBox)=>{

      // this.$http.get('http://localhost:44923/pages/NoteInfo.aspx?soft=easyicon')
      this.$http.get('/pages/NoteInfo.aspx', {params:{soft: this.soft, link: haveToolBox}})
      .then((response)=>{
        // console.log("log信息");
        // console.log(response);

        that.tittle = response.data.tittle;
        that.url = response.data.url==undefined? "" : response.data.url;
        that.note = that.FromBase64(response.data.note);
        
        that.visible = true;
      })
      .catch((response)=>{
          console.log(response);
          that.tittle = "操作提示";
          that.note = "请先在首页选择，您需要查看的软件";

          that.visible = false;
      })

    })

  },

  methods: {
    
    // 将字符串转化为Base64
    ToBase64(data) {
      return new Buffer.from(data).toString("base64");
    },

    // 将Base64字符串转化为String
    FromBase64(base64) {
      return new Buffer.from(base64, "base64").toString();
    },

  }

}
</script>

<style scoped>

#page-detail {
    width: 60%;
    min-width: 810px;
    margin: 0 auto;
}

#page-detail .title {
    font-weight: 700;
    font-size: 24px;
    padding: 12px 0;
    border-bottom: 1px solid #ccc;
}

#page-detail .content {
    margin-top: 15px;
}

.content p {
    word-wrap: break-word;
}

/* .content img {
  max-width: 60%;
} */

a:hover {
    background-color: rgb(233,104,107);
}

.download {
    position: fixed;
    left: 80%;
    top: 75%;
    float: right;
    background: rgb(255,105,143);
    color: white;
    border: 2px solid gray;
    padding: 15px;
    margin: 20px;
    font-family: SimHei;
    font-size: 2em;
    text-size: 40px;
    text-align: center;
    text-decoration: none;
}

</style>


// WEBPACK FOOTER //
// src/components/PannelContent.vue